import { render } from "./Breadcrumbs.vue?vue&type=template&id=1db8c7ee"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"

import exportComponent from "/home/dyam/Documentos/ENSI/mi-stock-ensi-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__